import { useCheckoutStore, CheckoutStep } from '@stores/useCheckoutStore';

export type { CheckoutStep } from '@stores/useCheckoutStore';

interface UseCheckoutStepReturn {
  currentStep: CheckoutStep;
  setStep: (step: CheckoutStep) => void;
  goToOverview: () => void;
  goToMethod: () => void;
  goToAccountBinding: () => void;
  goToPayment: () => void;
  goToForm: () => void;
  goToSuccess: () => void;
}

export const useCheckoutStep = (): UseCheckoutStepReturn => {
  const {
    currentStep,
    setStep,
    goToOverview,
    goToMethod,
    goToAccountBinding,
    goToPayment,
    goToForm,
    goToSuccess,
  } = useCheckoutStore();

  return {
    currentStep,
    setStep,
    goToOverview,
    goToMethod,
    goToAccountBinding,
    goToPayment,
    goToForm,
    goToSuccess,
  };
};
